import { Tooltip } from './Tooltip';

export const TooltipWrap = ({ children, tooltipProps }) => {
	if (!tooltipProps || !tooltipProps.title) return children;

	return <Tooltip {...tooltipProps}>{children}</Tooltip>;
};
